<template>
    <div class="projectManage">        
        <top-component></top-component>
        <div class="content_wrap">  
            <h2 class="pro_title">客户问题反馈</h2>
            <div class="search-wrap">
                <Form :model="form" label-width="120px" size="mini">
                    <Row>                
                        <Col :span="12">
                            <FormItem label="关键词:" prop="keys">
                                <Input placeholder="针对所有的工单进行查询" v-model="form.keys" clearable></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>                
                        <Col :span="12">
                            <FormItem label="" prop="">
                                <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
                                <Button @click.native="resetForm" size="mini" class="iconfont icon-reset reset-btn">重置</Button>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <Row class="list-btn">
                <Col>
                    <Button plain size="mini" type="success" class="return" @click="add">新增</Button>
                    <Button plain size="mini" type="danger" class="return" @click="del">删除</Button>
                    <Button plain size="mini" type="primary" class="return" @click="signResolved">标记为已解决</Button>
                    <!-- <Button size="small" class="return" @click="add">导出</Button> -->
                </Col>
            </Row>
            <div class="list">
                <table-list :tableParam="tableParam" @change="tableChange" ref="table" class="table-list"></table-list>
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>

<script>
import { Form, FormItem, Row, Col, Button, Input } from 'element-ui'
import TopComponent from "../Components/TopComponentcopy.vue";
import BottomComponent from "../Components/BottomComponent.vue";
import tableList from '../Components/TableList.vue'
import popup from '../../common/plugin/dialog/index.js'
import Message from '../../common/utils/message' 
import SignPop from './sign'  //标记
import EditPop from './edit'  //新增或修改
import Axios from "@/api/diyaxios";
import Cookies from 'js-cookie'

export default {
    data(){
        return {
            form: {
                keys:'',
                cpkid:'',
                pageNum: 1,
                pageSize: 20
            },
            tableParam: {
                isCheckbox: true,
                isIndex: true,
                dataRes: { entities: null }, //接口数据data
                columns: [  //table head 表头
                    {prop: 'content', label: '问题描述', isSort: false },
                    {prop: 'createdate', label: '创建时间', isSort: false },
                    {prop: 'contantname', label: '联系人', isSort: false },
                    {prop: 'contactinfo', label: '联系方式', isSort: false },
                    { prop: 'contantways', label: '常用联系方式', enum:true, enumDeel: function(index, row){    //===========> enum: 是否枚举   enumDeel：处理返回值
                        let str = '';
                        if(row.contantways == '0'){
                            str = '电话';
                        }else if(row.contantways == '1'){
                            str = 'QQ';
                        }else if(row.contantways == '2'){
                            str = '邮箱';
                        }else if(row.contantways == '3'){
                            str = '微信';
                        }
                        return str; 
                    } },  
                    { prop: 'issaved', label: '是否解决', enum:true, enumDeel: function(index, row){    //===========> enum: 是否枚举   enumDeel：处理返回值
                        let str = '';
                        if(row.issaved == '0'){
                            str = '否';
                        }else if(row.issaved == '1'){
                            str = '是';
                        }
                        return str; 
                    } }, 
                    { prop: 'score', label: '满意度', enum:true, enumDeel: function(index, row){    //===========> enum: 是否枚举   enumDeel：处理返回值
                        let str = '';
                        if(row.score == '2'){
                            str = '非常满意';
                        }else if(row.score == '1'){
                            str = '一般';
                        }else if(row.score == '0'){
                            str = '非常不满意';
                        }else if (row.score == '-1'){
                            str = '-';
                        }
                        return str; 
                    } }, 
                    {
                        prop: 'cz', label: '操作', isChange: true, deel: [
                            {str:'修改', event:'updateInfo' }
                        ]
                    }
                ],
				isPagination:true, // 是否有分页
            }
        }

    },
    components:{ TopComponent, Form, FormItem, Row, Col, Button, Input, tableList, BottomComponent },
    created(){
        let vm = this;
        vm.form.cpkid = Cookies.get('erpGid');
        // console.info(Cookies.get())
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        onSubmit(data){
            let vm = this;
            vm.getDataList();
        },
        //重置
        resetForm(){
            this.form.keys = '';
        },
        tableChange(data){
            let vm = this;
            if (data.event == 'changePage') {  //翻页
                vm.form.pageNum = data.currentPage;
                vm.getList();
            }else if (data.event == 'changeSize') {  // 切换页数大小
                vm.form.pageSize = data.pageSize;
                vm.getList();
            }else if (data.event == 'updateInfo') {  // 切换页数大小
                vm.editPopup('1',data.row);
            }

        },
        getDataList(){
            let vm = this;
            Axios.post('/sxerp/pt/erpservice/crmworkorderissue/queryCustomeIssueList', {
                params: vm.form
            }).then(res => {
                var d = res.data;
                vm.tableParam.dataRes.entities = d.records;
                vm.tableParam.dataRes.pageSize =  d.size;
                vm.tableParam.dataRes.currentPage =  d.current;
                vm.$set(vm.tableParam.dataRes,'total',d.total);
            }).catch(err => {

            })
        },
        add(){
            let vm = this;
            vm.editPopup(0, {});
        },
        del(){
            let vm = this,
            d = vm.getGids(vm.$refs.table.getSelection(),'pkid');
            if(!d){
                Message.info({ title: '提示', message: '请选择数据！', type: 'info' });
                return
            }
            Message.confirm({
                message:'是否确认删除？',
                ok(){
                    Axios.post('/sxerp/pt/erpservice/crmworkorderissue/delete', {
                        params:{pkids:d}
                    },{
                        headers:{
                            'Content-Type':'application/json'
                        }
                    }).then(res => {
                        if(res){
                            vm.form.pageNum = 1;
                            vm.getDataList();
                            Message.info({title:'提示',message:'删除成功！',type:'success'})
                        }
                    }).catch(err => {

                    })
                }
            });
        },
         // 通过选中数组获取选中的gid
        getGids(arr = [],prop){
            if(arr.length < 1) return '';
            let gids = [];
            for(let i = 0; i < arr.length; i++){
                if(arr[i][prop]){
                    gids.push(arr[i][prop]);
                }
            }
            return gids.join();
        },
        editPopup(type, data){
            let vm = this;            
            vm.edit_pop= popup('<edit-pop @submit="submit" @close="close" :type="type" :data="data" />',{
                option:{
                    title: type=='0' ? '新增客户问题反馈' : '修改客户问题反馈',
                    width: '780px'
                },
                popup:{
                    data(){
                        return {
                            type: type,
                            data: data
                        }
                    },
                    components:{                            
                        EditPop
                    },
                    methods:{
                        submit(data){
                            vm.edit_pop.hide();
                            vm.getDataList();
                        },
                        close(){
                            vm.edit_pop.hide(); 
                        } 
                    }
                }
            });
            vm.edit_pop.show();
        },
        signResolved(){
            let vm = this,
            d = vm.getGids(vm.$refs.table.getSelection(), 'pkid');
            if(vm.$refs.table.getSelection().length > 0){
                vm.sign_pop= popup('<sign-pop @submit="submit" @close="close" :data="data" />',{
                    option:{
                        title: '标记为已解决',
                        width: '480px'
                    },
                    popup:{
                        data(){
                            return {
                                data: d
                            }
                        },
                        components:{                            
                            SignPop
                        },
                        methods:{
                            submit(data){
                                vm.sign_pop.hide();
                                vm.getDataList();
                            },
                            close(){
                                vm.sign_pop.hide(); 
                            } 
                        }
                    }
                });
                vm.sign_pop.show();
            }else{                
                this.$message({
                    message: '请至少勾选一条数据！',
                    type: 'info'
                })   
            }
        }
    }
}
</script>

<style lang="scss">
.projectManage{
    background-color: #f9f9f9;
    .content_wrap{
        margin: 20px auto;
        width: 1000px;
        background-color: #fff;
        padding: 40px 60px 140px;
        .date-input{
            float: left;
            width:130px;
            .el-input__inner{
                padding:0px 8px 0px 30px;
                width: 128px;
            }
        }
        .add_all{
            margin-bottom: 60px;
        }
        .search-btn{
            text-align: center;
            margin-top:20px;
            padding-bottom: 60px;
            border-bottom: 1px dashed #ccd7ea;
        }
        .pro_title{
            color:#333;
            font-size:18px;
            margin-bottom: 60px;
        } 
        .list-btn{
            margin: 20px 0px 10px;
            padding-top:20px;
            border-top: 1px dashed #ccd7ea;
        }
        .data_wrap{
            padding-top: 30px;
            &.top{
                margin-top:4%;
            }
            ul.clearfix_2{
                &.custorm{
                    width: 595px;
                    height: 72px;
                    margin: 0px auto;
                    li{
                        border-top:1px solid #ccd7ea;
                    }
                }
                width: 1140px;
                border-left:1px solid #ccd7ea;
                li{
                    float: left;
                    width: 177px;
                    text-align: center;
                    list-style: none;
                    border-right:1px solid #ccd7ea;
                    border-bottom:1px solid #ccd7ea;
                    background-color: #fcfcf5;
                    padding:10px;
                    // &:nth-child(2n-1){
                    //     background-color: #f9fbfd;
                    // }
                    &.t{
                        border-top:1px solid #ccd7ea;
                        margin-top: -1px;
                    }
                    h2{
                        font-size:20px;
                        color:#2765b3;
                        // padding-bottom: 10px;
                    }
                    span{
                        font-size:18px;
                        color:#666;
                        font-weight: bold;
                    }
                    &.tit{
                        background-color: #f9fbfd;
                        width:102px;
                        span{
                            line-height: 47px;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/ProjectManage/problemReport.vue